<template>
  <div class="form">
    <template>
      <h1>重置账号/密码</h1>
      <el-steps :active="templateIndex" finish-status="success" align-center>
        <el-step title="账号信息"></el-step>
        <el-step title="安全认证"></el-step>
        <el-step title="重置账号/密码"></el-step>
      </el-steps>
    </template>
    <div class="form-body" v-loading="loading">

      <template v-if="templateIndex == 0">
        <el-alert show-icon title="账号信息"
                  description="请输入您的登录账号。" type="info" effect="dark"></el-alert>
      </template>
      <template v-if="templateIndex == 1">
        <el-alert show-icon title="现在进行安全认证"
                  description="我们刚刚发送了一条短信到您绑定的手机上，请输入短信中的验证码。" type="warning" effect="dark"></el-alert>
      </template>
      <template v-if="templateIndex == 2">
        <el-alert show-icon title="恭喜！安全验证成功！"
                  description="现在您可以重置您的账号/密码了，请勿刷新当前页面！" type="success" effect="dark"></el-alert>
      </template>

      <auto-form ref="form" :rules="rules" :form="form" label-width="110px" :url="url.save" @beforeSave="beforeSave"
                 @afterSaved="afterSaved"
                 :isEdit="true" :formTemplate="formTemplates[templateIndex]" @saved="onSaved"
                 :canEdit="true"></auto-form>
      <template>
        <div v-if="templateIndex == 2">
          <el-button type="primary" class="btn-register" @click="save">保存</el-button>
        </div>
        <div v-else>
          <el-button type="primary" class="btn-register" @click="next">下一步</el-button>
        </div>

      </template>

    </div>
  </div>
</template>

<script type="text/javascript">

import AutoForm from '@/components/AutoForm'

export default {
  components: {
    AutoForm
  },
  props: {},
  data() {
    // 再次输入密码验证
    let validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.form.Password) {
        callback(new Error('两次输入的密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      Phone: '',

      url: {
        sendVcode: SZH.assets.api + "/Custom/CheckCustomAccount",
        sendNewVcode: SZH.assets.api + "/Custom/SendVerifyCodeForWeb",
        CheckVerifyCodeForForgetPassword: SZH.assets.api + "/Custom/CheckVerifyCodeForForgetPassword,",//templateIndex ==2
        validateVCode: SZH.assets.api + "/Custom/CheckVerifyCodeForForgetPassword",
        save: SZH.assets.api + "/Custom/UpdatePwdForForgetPassword ",
      },
      form: {
        Account: '',
        captcha: '',
        vcode: '',
        Password: '',
        RePassword: '',
        ContactsName: '',
        ContactCardNumber: '',
        UserNameNew: ''
      },
      templateIndex: 0,
      formTemplates: [
        [
          {col: 24, tips: '账号信息', type: 'tips'},
          {col: 24, label: '原登录账号', prop: 'Account'},
          {col: 24, label: '验证码', prop: 'captcha', type: 'captcha'},
        ],
        [
          {col: 24, tips: '安全认证', type: 'tips'},
          // { col: 24, label: '联系人', prop: 'ContactsName' },
          // { col: 24, label: '身份证', prop: 'ContactCardNumber' },
          {
            col: 24, label: '短信验证码', prop: 'vcode', type: 'v-code', click: (c) => {
              this.sendNewVcode(c);
            }
          },
        ],
        [
          {col: 24, tips: '重置账号/密码', type: 'tips'},
          // {col: 24, label: '新登录账号', prop: 'UserNameNew'},
          {col: 24, label: '新密码', prop: 'Password', type: 'password'},
          {col: 24, label: '确认密码', prop: 'RePassword', type: 'password'},
        ],
      ],
      rules:
        {
          Account: [{required: true, message: '请输入您的登录用户名或绑定手机号', trigger: 'blur'}],
          captcha: [{required: true, message: '请输入验证码', trigger: 'blur'}],
          vcode: [{required: true, message: '请输入短信验证码', trigger: 'blur'}],
          Password: [
            {required: true, message: '请输入新密码', trigger: 'blur'},
            {
              validator: validatePassword,
              trigger: 'blur'
            }
          ],
          RePassword: [
            {required: true, message: '请再次输入新密码', trigger: 'blur'},
            {
              validator: validateConfirmPassword,
              trigger: 'blur'
            }
          ],
          UserNameNew: [
            {
              required: true,
              message: '请输入新登录账号',
              trigger: 'blur'
            },
            {
              min: 6,
              max: 25,
              message: '登录账号长度应在 6 到 25 个字符之间',
              trigger: 'blur'
            },
            {
              validator: validateUsername,
              trigger: 'blur'
            }
          ],
          ContactsName: [{required: true, message: '请输入联系人', trigger: 'blur'}],
          ContactCardNumber: [
            {required: true, message: '请输入身份证号', trigger: 'blur'}, {validator: validateIdCard, trigger: 'blur'}
          ]
        },
      formChange: {
        ContractsCardNumber: false,
        Account: false
      },
      checkbox: false,
      loading: false,
      userNameIsOk: false,
      customNameIsOk: false,
      bankIsOk: true,
    }
  },
  methods: {
    save() {
      // let self = this
      // let arr = ['000', '111', '222', '333', '444', '555', '666', '777', '888', '999', '123', '234', '345', '456', '567', '678', '789'];
      // let flag = false;
      // for (let i = 0; i < arr.length; i++) {
      //   if (self.form.Password.indexOf(arr[i]) > -1) {
      //     flag = true;
      //     break
      //   }
      // }
      // //
      // // let flag = arr.some(item=>{
      // //   return this.form.Password.indexOf(item) >-1
      // // });
      // if (flag) {
      //   this.$message.error('密码强度太弱，禁止（111，123）这种连续重复数字格式！');
      //   return
      // }
      this.$refs['form'].submit();
    },
    beforeSave() {
      this.form.Password = hex_md5(this.form.Password);
      this.form.RePassword = hex_md5(this.form.RePassword);
      this.loading = true;
    },
    onSaved() {
      this.$message.success("修改成功！");
      this.$router.push({
        path: '/LoginTH'
      })
    },
    afterSaved() {
      this.loading = false;
    },
    subm() {
      self.templateIndex = self.templateIndex - 1
    },
    next() {
      var self = this;
      if (self.templateIndex == 0) {
        self.$refs['form'].validate(v => {
          if (v) {
            self.sendVcode()
          } else {
            return false;
          }
        });
      } else if (self.templateIndex == 1) {
        self.$refs['form'].validate(v => {
          if (v) {
            self.loading = true;
            self.$http.post(self.url.validateVCode, {
              Account: self.form.Account,
              Phone:self.Phone,
              VCode:self.form.vcode
            }).then(result => {
              if (result.state == true) {
                self.$message.success("验证成功！");
                self.goNext();
              } else {
                self.$message.error(result.message);
                self.$refs['form'].refreshCaptcha();
              }
              self.loading = false;
            }, () => {
              self.loading = false;
            });
          } else {
            return false;
          }
        });
      }
    },
    goNext() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.form.UserNameNew = this.form.Account;
          // this.formTemplates[2][1].cannotEidt = false;
          this.templateIndex++;
          this.sendNewVcode()
        } else {
          return false;
        }
      });
    },
    sendVcode() {
      var self = this;
      self.loading = true;
      self.$http.post(self.url.sendVcode, {
        Account: self.form.Account,
        Captcha: self.form.captcha,
      }).then(result => {
        if (result.state == true) {
          self.Phone = result.data
          self.goNext();
        } else {
          self.$message.error(result.message);
          self.$refs['form'].refreshCaptcha();
        }
        self.loading = false;
      }, () => {
        self.loading = false;
      });

    },
    sendNewVcode(collback) {
      var self = this;
      self.loading = true;
      self.$http.post(self.url.sendNewVcode, {
        Account: self.form.Account,
        Phone: self.Phone,
        SmsTemplateType: 8,
      }).then(result => {
        if (result.state == true) {
          self.$message.success("验证码发送成功！");
          collback()
        } else {
          self.$message.error(result.message);
          self.$refs['form'].refreshCaptcha();
        }
        self.loading = false;
      }, () => {
        self.loading = false;
      });

    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  watch: {}
}
</script>

<style type="text/css" scoped>

.xieyi-footer {
  text-align: center;
}

.form {
  /* border: 1px solid #000; */
  max-width: 800px;
  margin: 0 auto;
  padding-top: 40px;
}

.form > h1 {
  margin-bottom: 30px;
  border-bottom: 2px solid #808080;
  padding-bottom: 10px;
}

.form .checkbox {
  padding-left: 30px;
}

.btn-register {
  width: calc(100% - 10px);
  margin: 10px 5px 20px;
}

.form-body {
  max-width: 600px;
  margin: 0 auto;
}


@media screen and (max-width: 450px) {

  .form {
    padding: 10px 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Password/Password.vue